import * as React from "react";
import { Component } from "react";
import { Moment } from "moment";

import { DateSelectField, TextField } from "components";
import { DebtorType } from "types";
import { maxBirthDateYear } from "utils/DateFormatters";

interface PropsType {
  debtor: DebtorType;
  isDateOfBirthValid(): boolean;
  onFieldBlur(): void;
  onFieldChange(e: { currentTarget: { name: string; value: string } }): void;
}

export default class PersonalInfo extends Component<PropsType> {
  onDateOfBirthSelect = (date: Moment): void => {
    this.props.onFieldChange({
      currentTarget: {
        name: "dateOfBirth",
        value: date.format("YYYY-MM-DD"),
      },
    });
  };

  render(): JSX.Element {
    const {
      debtor,
      isDateOfBirthValid,
      onFieldBlur,
      onFieldChange,
    } = this.props;

    return (
      <section className="personal-info">
        <div className="form--fieldset">
          <div className="content">
            <header>
              <div className="badge">
                <i className="fas fa-user-circle" />
              </div>

              <h3>Personal Information</h3>
            </header>

            <div className="body">
              <div className="form--field-group">
                <TextField
                  label="First Name"
                  name="firstName"
                  onBlur={onFieldBlur}
                  onChange={onFieldChange}
                  placeholder="First Name"
                  value={debtor.firstName}
                />

                <TextField
                  label="Middle Name"
                  name="middleName"
                  onBlur={onFieldBlur}
                  onChange={onFieldChange}
                  placeholder="Middle Name"
                  value={debtor.middleName || ""}
                />
              </div>

              <TextField
                label="Last Name"
                name="lastName"
                onBlur={onFieldBlur}
                onChange={onFieldChange}
                placeholder="Last Name"
                value={debtor.lastName}
              />

              <DateSelectField
                defaultValue={debtor.dateOfBirth}
                error={isDateOfBirthValid() ? null : "Invalid Date of Birth"}
                label="Date of Birth"
                maxYear={maxBirthDateYear()}
                onBlur={onFieldBlur}
                onChange={this.onDateOfBirthSelect}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
